import { useLocation, useParams } from 'react-router-dom';

export const useBasePath = () => {
  const location = useLocation();
  // useParams returns all dynamic params as an object (e.g., { id: '123' })
  const params = useParams();

  // Start with the full pathname
  let basePath = location.pathname;

  // Iterate over all parameter values and replace them with an empty string in the path
  Object.values(params).forEach((paramValue) => {
    // Escapes special characters for the regex and ensures only the full segment is replaced
    const escapedValue = paramValue?.replaceAll(/[.*+?^${}()|[\]\\]/g, '\\$&');
    const regex = new RegExp(`/${escapedValue}`);
    basePath = basePath.replace(regex, '');
  });

  return basePath;
};
